import { createRoute } from "@tanstack/react-router";

import { brandRoute, isUuid } from "../../platform/routes";
import { EditorScreen } from "./EditorScreen";
import { OpenAssetScreen } from "./OpenAssetScreen";
import { ProjectListScreen } from "./ProjectListScreen";

/** The brand's edit projects (E1): a project belongs to one brand, as its media does. */
export const editorProjectsRoute = createRoute({
  getParentRoute: () => brandRoute,
  path: "editor",
  component: ProjectListScreen,
});

/** One project open in the editor, which covers the app's frame as live's editor does. */
export const editorProjectRoute = createRoute({
  getParentRoute: () => brandRoute,
  path: "editor/$projectId",
  staticData: { fullWindow: true },
  params: { parse: ({ projectId }) => (isUuid(projectId) ? { projectId } : false) },
  component: EditorScreen,
});

/** Live's Open in the editor (#668, S1c): a library video's own project, found or made. */
export const editorFromAssetRoute = createRoute({
  getParentRoute: () => brandRoute,
  path: "editor/asset/$assetId",
  params: { parse: ({ assetId }) => (isUuid(assetId) ? { assetId } : false) },
  component: OpenAssetScreen,
});
